import"react";var O;!function(O){O.ZOOMING_IN="ZOOMING_IN",O.ZOOMING_OUT="ZOOMING_OUT"}(O||(O={}));export{O as ZoomState};
//# sourceMappingURL=usePinchZoom.js.map
